import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const BackArrow = ({ className = "" }) => {
  const navigate = useNavigate();
  const goBack = () => {
    if (window.history.length > 2) navigate(-1);
    else navigate("/");
  };
  return (
    <button
      onClick={goBack}
      data-testid="back-arrow-btn"
      aria-label="Back"
      className={`inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/5 border border-white/15 text-white/60 hover:text-white hover:bg-[#B026FF]/15 hover:border-[#B026FF]/40 transition-colors ${className}`}
    >
      <ArrowLeft size={18} />
    </button>
  );
};
